import { Link, NavLink, Outlet } from "react-router-dom";
// Auth lives under gym/ from when this was a Gym-only app; it's genuinely
// platform-wide now, shared here rather than duplicated.
import { useAuth } from "../../gym/auth/useAuth";
import { login, logout } from "../../gym/auth/authClient";
import { Footer } from "./Footer";
import logoUrl from "../../assets/logo.png";

/** Shell for platform-level pages (the module chooser, Benefits) — same
 * header chrome as AppLayout but no module-specific nav. */
export function PlatformLayout() {
  const { principal, isAuthenticated } = useAuth();

  return (
    <div className="app-shell">
      <header className="app-header">
        <Link to="/" className="brand">
          <img className="brand-logo" src={logoUrl} alt="Madinet Masr" />
          <div>
            <div className="brand-title">Madinet Masr</div>
            <div className="brand-sub">Employee Platform</div>
          </div>
        </Link>

        <nav className="app-nav">
          <NavLink to="/" end className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}>
            Home
          </NavLink>
          <NavLink to="/about" className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}>
            About Madinet Masr
          </NavLink>
        </nav>

        <div className="app-account">
          {isAuthenticated ? (
            <>
              <span className="account-email">{principal?.userDetails}</span>
              <button className="btn btn-ghost" onClick={logout}>
                Sign out
              </button>
            </>
          ) : (
            <button className="btn btn-primary" onClick={() => login()}>
              Sign in
            </button>
          )}
        </div>
      </header>

      <main className="app-main">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
